import { time } from "@bodil/core";
import { DisposableContext, timeout } from "@bodil/core/disposable";
import { attribute, Component } from "@bodil/dom/component";
import { getComputedProperty, parseTime } from "@bodil/dom/css";
import { html } from "lit";
import { customElement } from "lit/decorators.js";
import { createRef, ref } from "lit/directives/ref.js";

import styles from "./floater.css?inline";

declare global {
    interface HTMLElementTagNameMap {
        "btk-floater": BtkFloater;
    }
}

@customElement("btk-floater")
export class BtkFloater extends Component {
    @attribute accessor placement: "top" | "bottom" = "top";

    floater = createRef<HTMLDivElement>();

    private readonly pinContext = new DisposableContext();

    protected override render() {
        return html`
            <slot
                name="anchor"
                @mouseenter=${this.handleAnchorMouseEnter}
                @mouseleave=${this.handleAnchorMouseLeave}
            ></slot>
            <div ${ref(this.floater)} class="floater">
                <slot part="panel" role="tooltip"></slot>
            </div>
        `;
    }

    protected override connected() {
        super.connected();
        this.useWhileConnected(this.on("mouseleave", this.handleMouseLeave.bind(this)));
    }

    private resetPin() {
        this.pinContext.dispose();
        this.floater.value?.classList.remove("pinned");
    }

    private handleAnchorMouseEnter() {
        if (this.floater.value?.classList.contains("pinned") !== true) {
            this.resetPin();
            const t = getComputedProperty(this, "--pin-timeout").chain(parseTime).map(time.millis);
            this.pinContext.use(
                timeout(
                    () => {
                        this.floater.value?.classList.add("pinned");
                    },
                    t.getOrElse(() => time.seconds(1)),
                ),
            );
        }
    }

    private handleAnchorMouseLeave() {
        if (this.floater.value?.classList.contains("pinned") !== true) {
            this.resetPin();
        }
    }

    private handleMouseLeave() {
        this.resetPin();
    }

    static styles = styles;
}
